"use client";

import { createPath } from "@/service/routing/routing";
import { SpacedRepetitionCard } from "./components/spaced-repetition-card";

export const ExamLearningPlan = ({
  learningPlan,
  newCount = 0,
  reviewCount = 0,
  overdueCount = 0,
  completedCount = 0,
}: {
  learningPlan: ExamLearningPlanVM;
  setup: ExamSetupVM;
  dailyQuestions?: number;
  questionSetLabel?: string;
  reviewPace?: number;
  newCount?: number;
  reviewCount?: number;
  overdueCount?: number;
  completedCount?: number;
}) => {
  const isLearningPlan = learningPlan.days.some((d) => d.active);

  const configureHref = createPath("exam.spaced_repetition.configure");
  const startHref = createPath("exam.start_spaced_repetition");

  return (
    <SpacedRepetitionCard
      notConfigured={!isLearningPlan}
      newCount={newCount}
      overdueCount={overdueCount}
      // reviewCount z backendu zawiera zaległe — odejmujemy je, by „Zaległych" i „Powtórki" były rozłączne.
      reviewCount={Math.max(0, reviewCount - overdueCount)}
      completedCount={completedCount}
      startHref={startHref}
      configureHref={configureHref}
    />
  );
};
